import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import {CURRENT_VISIT_URL_LIST} from "@/services/visit";
import  store  from '../../../state/store';

async function getCurrentVisitList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentVisitSingle(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_SINGLE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function addCurrentVisit(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_ADD_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function updateCurrentVisit(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_UPDATE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}


async function deleteCurrentVisit(params, body,urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_DELETE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function updateCurrentVisitStatus(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(CURRENT_VISIT_URL_LIST.CURRENT_VISIT_CHANGE_STATUS_URL),
        post: body
    }
    return prepareRequest(config,request);
}

export {
    getCurrentVisitList,
    getCurrentVisitSingle,
    addCurrentVisit,
    deleteCurrentVisit,
    updateCurrentVisitStatus,
    updateCurrentVisit,
};
